import { Component, OnInit } from '@angular/core';
import { HydroConditionService } from 'src/app/services/hydro-condition.service';

@Component({
  selector: 'app-hydro-condition-button',
  templateUrl: './hydro-condition-button.component.html',
  styleUrls: ['./hydro-condition-button.component.scss']
})
export class HydroConditionButtonComponent implements OnInit {

  updatingCondition: boolean;
  private selectedCondition: string = "Select Hydrologic Condition";
  private conditionSelected: boolean = false;
  private currentHydroCondition: string;

  constructor(private hydroConditionService: HydroConditionService) {}

  ngOnInit() {
    this.hydroConditionService.currentHydroCondition.subscribe((result) => {
      if (result) { this.currentHydroCondition = result.demandCondition; }
      else { this.currentHydroCondition = "Error"; }

    });
  }

  toggleUpdating() {
    this.updatingCondition = !this.updatingCondition;
  }

  updateSelection(selection) {
    this.selectedCondition = selection;
    this.conditionSelected = true;
  }

  cancel() {
    this.toggleUpdating();
    this.selectedCondition = "Select Hydrologic Condition";
    this.conditionSelected = false;
  }

  onSubmit() {
    if      (this.selectedCondition === "Wet")    { this.hydroConditionService.postHydroCondition(1); }
    else if (this.selectedCondition === "Normal") { this.hydroConditionService.postHydroCondition(2); }
    else if (this.selectedCondition === "Dry")    { this.hydroConditionService.postHydroCondition(3); }
    this.cancel();
  }

}
